<script>
import ListDefault from "../../Utils/Page/ListDefault";

export default {
    name: "List",
    mixins: [ListDefault],
    data() {
        return {
            lang: this.$ml.get('pages.promo_code'),

            filter: {
                code: { value: null, type: 'text'},
                membership_type: { value: null, type: 'select',
                    options: [
                        { id: 'regular', title: 'regular' },
                        { id: 'pro', title: 'pro' },
                    ]
                },
            },
            tableHeader: [
                //{ label: '#', is_sort: false },
                { key: 'id', is_sort: true },
                { key: 'code', is_sort: true, classes: 'text-l' },
                { key: 'sale', is_sort: true, classes: 'text-l' },
                { key: 'amount', is_sort: true, classes: 'text-l' },
                { key: 'membership_type', is_sort: true, classes: 'text-l' },
                { key: 'date_start', is_sort: true, classes: 'text-l' },
                { key: 'date_finish', is_sort: true, classes: 'text-l' },
                { key: 'counter', is_sort: true, classes: 'text-l' },
                { key: 'count', is_sort: true, classes: 'text-l' },
            ],

            tableBody: {
                sale: {type: 'function', function: this.getSaleLabel},
                amount: {type: 'function', function: this.getAmountLabel},
            },

            apiList: this.$store.getters.getApiUrl('marketing.promo_code'),
            pageRoute: 'promo_code',
            pageRouteCreate: 'promo_code.create',
            pageRouteEdit: 'promo_code.edit',
            pagePermission: 'marketing.promo_code',
        }
    },
    methods: {
        getSaleLabel(item) {
            return item.sale ? `${item.sale}%` : '-'
        },
        getAmountLabel(item) {
            let text = item.plan_discounts.map(el => {
                const saleValue = el.amount ? `<b>$${ el.amount }</b>` : `<b>${item.sale ?? '-' }%</b>`
                return `${saleValue} - ${ el.plan.title }`
            })

            return text.length ? text.join('<br>') : '-'
        },
    }
}
</script>
